export const CircleFillTickIcon = ({
  strokeColor = "var(--color-green)",
  ...props
}: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill={strokeColor}
      d="M8 1.333C4.328 1.333 1.335 4.326 1.335 8c0 3.673 2.993 6.666 6.667 6.666 3.673 0 6.666-2.993 6.666-6.666 0-3.674-2.993-6.667-6.666-6.667Zm3.187 5.133-3.78 3.78a.5.5 0 0 1-.706 0L4.814 8.36a.503.503 0 0 1 0-.707.503.503 0 0 1 .707 0l1.533 1.533 3.427-3.426a.503.503 0 0 1 .706 0 .503.503 0 0 1 0 .706Z"
    />
  </svg>
);
